import { useMutation, useQueryClient } from '@tanstack/react-query';

import type { DocumentLink } from '@/openapi';
import { DocumentsService } from '@/openapi';
import { queryKeys } from '@/util/queryKeys';

export const useCreateDocumentLinkMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (documentLink: DocumentLink) => {
      await DocumentsService.documentsServiceCreateDocumentLink({
        body: documentLink,
      });
    },
    onSettled: async () => {
      await Promise.all([
        queryClient.invalidateQueries({
          queryKey: queryKeys.documents.links(),
        }),
        queryClient.invalidateQueries({
          queryKey: queryKeys.documents.metadata(),
        }),
      ]);
    },
  });
};
